import React from 'react';
import { connect } from 'react-redux'
import { apiUrl } from './../constants/apiUrl'
import api from './../service/apiService'
import { logKafka } from './../service/logService'
import * as buildProductAction from './../action/buildProduct'

class GlobalChat extends React.PureComponent {    
  constructor(props)
  {
    super(props);
    window.setChatAgentInfo= this.setChatAgentInfo.bind(this);
    window.UpdatePromationFromChatRecording= this.UpdatePromationFromChatRecording.bind(this);
    window.UpdatePromationFromChat= this.UpdatePromationFromChat.bind(this);
  }
  //UpdatePromationFromChatNC('DNRD-9594-9431')"
  UpdatePromationFromChatRecording(ChatPromoIds) {    
    buildProductAction.updateCartChatOffer(this.props.appState.visitId,this.props.buildProduct.recording.equipments,ChatPromoIds,this.props.dispatch,this.props.buildProduct);    
  }
  UpdatePromationFromChat(ChatPromoIds)
  {
    //buildProductAction.updateCartChatOfferCoupon(this.props.appState.visitId,ChatPromoIds,this.props.dispatch);    
    buildProductAction.updateCartChatOfferCoupon(this.props.appState.visitId, this.props.buildProduct.contract.contractType,
      this.props.dispatch, this.props.lqState.selectedState.zip, this.props.lqState.lqResponse.tarCode, 
      this.props.buildProduct.selectedCoreServices,this.props.buildProduct.masterpackageview, '',ChatPromoIds, this.props.lqState.servicesQualified);    
    
  }
  
  setChatAgentInfo(agentId, chatSessionId, agentSalesCode, timeStamp) {
    let pathName = window.location.href;
    let url = apiUrl().chatStore;
    api(url, 'POST', getRequest(this.props.appState.visitId, this.props.appState.visitorId, agentId, chatSessionId, agentSalesCode,pathName))
      .then(response => {
          let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
          if (response.meta.code === 200 && response.chatInfo.status==="Success") {
              logKafka("SUCESS", "ChatStore Info Logging","chat infor stored", getErrorLogUrl, "applogs", this.props.appState.visitId);
          }   
          else
          {
            logKafka("SUCESS", "ChatStore Info Logging", "chat infor stored throws Error", getErrorLogUrl, "applogs", this.props.appState.visitId);
          }
      })
      .catch(error => {
          let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
          logKafka("ERROR", "ChatStore Info Logging", error.message, getErrorLogUrl, "applogs", this.props.appState.visitId);
      });
    }
  render() {
    return (        
      null
    );
  }
}
const mapStateToProps = (state) => {
  return {
    appState: state.app,
    buildProduct:state.buildProduct,
    lqState: state.loopQual,
    
  }
}
export default connect(
  mapStateToProps
)(GlobalChat);

const getRequest = (visitId, visitorId, agentId, chatSessionId, agentSalesCode, pageUrl) => {
  let request = {
      visitId: visitId,
      visitorId: visitorId,
      agentId: agentId,
      trackingId: chatSessionId,
      agentSalesId: agentSalesCode,
      pageUrl: pageUrl
  }
  return JSON.stringify(request);
};